/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 7V17M12 7L9.5 9.5M12 7L14.5 9.5M12 17L9.5 14.5M12 17L14.5 14.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21 3H3M21 21H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M21 3H3M12 7V17M12 7L9.5 9.5M12 7L14.5 9.5M12 17L9.5 14.5M12 17L14.5 14.5M21 21H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M21 3H3M12 7V17M12 7L9.5 9.5M12 7L14.5 9.5M12 17L9.5 14.5M12 17L14.5 14.5M21 21H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M18 3H21M3 3H14M12 7V17M12 7L9.5 9.5M12 7L14.5 9.5M12 17L9.5 14.5M12 17L14.5 14.5M6 21H3M21 21H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M21 3H3M12 7V17M12 7L9.5 9.5M12 7L14.5 9.5M12 17L9.5 14.5M12 17L14.5 14.5M21 21H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M21 3H3M12 7V17M12 7L9.5 9.5M12 7L14.5 9.5M12 17L9.5 14.5M12 17L14.5 14.5M21 21H3"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
